import { EParkingType } from 'shared/types/filters/advanced/parkingType';

export const ALL_AVAILABLE_PARKING_TYPES = [
  EParkingType.Rooftop,
  EParkingType.Underground,
  EParkingType.Ground,
  EParkingType.Multilevel,
];
